import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ToastrService } from 'ngx-toastr'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormControl } from '@angular/forms';
import { JoditAngularComponent } from 'jodit-angular';
import { Editor } from 'ngx-editor';

@Component({
  selector: 'app-variable-pay-email-content',
  templateUrl: './variable-pay-email-content.component.html',
  styleUrls: ['./variable-pay-email-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VariablePayEmailContentComponent implements OnInit {

  buttonColorName: any;
  EmailContent: any
  isEditEmail = false
  emailContentSubject: any;
  isInvalidIncrementEmailSubject: any = false;
  emailContentBody: any;
  isInvalidsetIncrementEmailContent: any = false;
  loggedInUserCompanyID: any;
  fromYear: any;
  toYear: any;
  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //     spellcheck: true,
  //     height: '400px',
  //     minHeight: '0',
  //     maxHeight: 'auto',
  //     width: 'auto',
  //     minWidth: '0',
  //     translate: 'yes',
  //     enableToolbar: true,
  //     showToolbar: true,
  //     placeholder: 'Enter Email here...',
  //     defaultParagraphSeparator: '',
  // }

  // -------------------------------------------------------------------------------------------------------------------------------------
  employeeApplicationEmailBody: any = null;
  vpletterContent: any = null
  offerlaterEmailBody: any = null;
  public Editor = ClassicEditor;

  text: string = '<p>Hello, this is default text in editor!</p>'; // ✅ Default text



  editorContent: string = '<p>Welcome to Jodit Editor!</p>';
  submissionEmailBody: any = null;
  appoinmentlaterEmailBody: any = null;
  textControl = new FormControl('<p>Hello, this is default text in editor!</p>'); // ✅ Use FormControl
  isEditing = false;

  editorConfig: any = {
    height: 430,
    toolbarSticky: false,
    toolbarAdaptive: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    // defaultActionOnPaste: 'insert_clear_html',
    defaultActionOnPaste: 'insert_as_html',

    language: 'en',
    i18n: {
      en: {
        // ✅ Title
        'Paste as HTML': 'Paste',

        // ✅ Message body
        'Your code is similar to HTML. Keep as HTML?':
          ' Do you want to keep this content as it is ?',
      }
    },
    uploader: {
      insertImageAsBase64URI: true
    },
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'left', 'center', 'right', 'justify', '|',
      'preview', '|',
      'undo', 'redo', '|',
      'fontsize',
      'link'
    ]
  };



  @ViewChild('joditEditor') joditEditor!: JoditAngularComponent;
  // ------------------------------------------------------------------------------------------------------------------
  vppolicySubjectCharValidation = false;
  editor: any
  allemailtempalteData: any = [];
  invitationEmailSubject: any;
  employeeApplicationEmailBodyFromBAckendfrontEndEmail: any
  popupName = 'Create Email Body for Employment application'
  constructor(public dialog: MatDialog, public router: Router, private httpService: HttpService,
    private config: Config, private encryptionService: EncryptionService, private toastr: ToastrService) { }

  ngOnInit() {
    // this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.getVPPolicyFile();


  }
  mailTemplateSave() {
    if (this.popupName == 'Create Email Body for Employment application') {

      let emailbody = this.allemailtempalteData;
      console.log(emailbody);

      let emailbodytemlate = emailbody[0]?.body;
      console.log(emailbody);


      if (emailbody) {
        this.vpPolicyUrlSubject = emailbody?.vpPolicyUrlSubject;
        this.vpletterContent = emailbody?.vpPolicyFileNameBody || `Dear <b>#EMPLOYEE_NAME#</b>, 
      <br /> <br />
      We are happy to announce that you are eligible for Variable Pay (VP) for [Period/Year] as a recognition of your contributions and dedication.
      <br /><br />
      To view your VP letter, please follow these simple steps:
      <br />
      <ol>
        <li style="margin-left:15px;">Click on the PHI HRIS login link: [Login Link]</li>
        <li style="margin-left:15px;">Enter your credentials to access system.</li>
        <li style="margin-left:15px;">Navigate to the VP Module from your Landing page</li>
        <li style="margin-left:15px;">Your VP letter is available there for your reference.</li>
      </ol>
      <br />
      We truly appreciate your hard work and commitment to [Company Name], and we look forward to achieving more success together!
      <br /><br />
      For any queries, feel free to reach out to [HR Contact Details].
      <br />
      Congratulations once again!
      <br/><br/>
      Best regards, 
      <br />[HR Name],
      <br />[HR Position],
      <br />[Company Name],
      <br />[HR Contact Details]`;

      }
      else {
        this.employeeApplicationEmailBodyFromBAckendfrontEndEmail = 'ELCM_EMPLOYEE_APPLICATION';
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.vpletterContent = `Dear <b>#EMPLOYEE_NAME#</b>, 
      <br /> <br />
      We are happy to announce that you are eligible for Variable Pay (VP) for [Period/Year] as a recognition of your contributions and dedication.
      <br /><br />
      To view your VP letter, please follow these simple steps:
      <br />
      <ol>
        <li style="margin-left:15px;">Click on the PHI HRIS login link: [Login Link]</li>
        <li style="margin-left:15px;">Enter your credentials to access system.</li>
        <li style="margin-left:15px;">Navigate to the VP Module from your Landing page</li>
        <li style="margin-left:15px;">Your VP letter is available there for your reference.</li>
      </ol>
      <br />
      We truly appreciate your hard work and commitment to [Company Name], and we look forward to achieving more success together!
      <br /><br />
      For any queries, feel free to reach out to [HR Contact Details].
      <br />
      Congratulations once again!
      <br/><br/>
      Best regards, 
      <br />[HR Name],
      <br />[HR Position],
      <br />[Company Name],
      <br />[HR Contact Details]`;
      }
    } else if (this.popupName == 'Create Email Body for Intimation email') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'Intimation email from candidate');

      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
      I Candidate name have submitted the employment application form with supportings. All information provided by me is <br>
      accurate.
      `;

      }
    }
  }
  flag: any
  flagforread:any
  onClickEdit() {
    this.flag = "edit"
    this.isEditEmail = true;
    
    setTimeout(() => {
      this.mailTemplateSave();
    }, 300)
    this.editor = new Editor();
  }

  isDiscardChanges() {
   
    this.isEditEmail = false;
    this.emailContentSubject = "";
    this.emailContentBody = "";
    this.getVPPolicyFile()
  }

  onClickGoToVariablePay(operation: any) {
    this.router.navigate(['/home/hrportal/variablepay', { operation: operation }]);
  }

  onClickSaveBtn() {
    if (!this.emailContentSubject && this.emailContentBody) {
      window.alert("Enter Email Subject")
    }

    if (!this.emailContentBody && this.emailContentSubject) {
      window.alert("Enter Email")
    }

    if (!this.emailContentSubject && !this.emailContentBody) {
      window.alert("Enter Email and Email Subject")
    }

    if (this.emailContentSubject && this.emailContentBody) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '30%',
        width: '30%',
        data: {
          msg: 'Email Template Updated Successfully',
          btn2: 'Done',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.isEditEmail = false;
          this.emailContentSubject = '';
          this.emailContentBody = '';
          const request = {
            "companyId": this.loggedInUserCompanyID,
            "emailContentBody": this.emailContentBody,
            "emailContentSubject": this.emailContentSubject,
            "fromYear": 0,
            "variablePayPolicyFileName": null,
            "variablePayPolicyUrl": null,
            "toYear": 0
          };
          this.httpService.callPostService(this.config.variablePayPolicyUpload, request).subscribe((result) => {
            // this.getIncrementSetup();
            console.log(result)
          });
        }
      });
    }
  }

  vpPolicyUrlSubject: any = `Congratulations! You Are Eligible for Variable Pay – [Period/Year]`;

  saveVPPolicyFile() {
    if (this.vpletterContent == '') {
      this.toastr.error('Please fill email body.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (this.vpPolicyUrlSubject == '') {
      this.toastr.error('Please fill email subject.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (this.vpPolicyUrlSubject.length >= 255) {
      this.vppolicySubjectCharValidation = true;
    } else {
      this.vppolicySubjectCharValidation = false;
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "frequencyCycle": null,
        "fromYear": null,
        "isDeleted": false,
        "relatedToName": "Email Content",
        "toYear": null,
        "vpPolicyFileNameBody": this.vpletterContent,
        "vpPolicyUrlSubject": this.vpPolicyUrlSubject
      };
      this.httpService.callPostService(this.config.saveVPPolicyFile, request).subscribe((result: any) => {

        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: result?.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
         
          this.getVPPolicyFile();
          let emailbody = this.allemailtempalteData;
        this.vpPolicyUrlSubject = emailbody?.vpPolicyUrlSubject;
        this.vpletterContent = emailbody?.vpPolicyFileNameBody;
        this.flag=''
        this.isEditEmail = false;
 
        });
      });
    }
  }
  vpPolicyUrlSubject1: any;
  vpletterContent1: any
  getVPPolicyFile() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": null,
      "relatedToName": "Email Content",
      "toYear": null,
      "isShowLetterLink": false
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
      if (result?.data != null) {
        this.allemailtempalteData = result?.data;
        this.vpPolicyUrlSubject = result.data?.vpPolicyUrlSubject;
        this.vpletterContent1 = result.data?.vpPolicyFileNameBody

      }
    });
  }

}
